<template>
  <div :class="clazz" class="ds-ex-pattern">
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Provide, Vue } from "vue-facing-decorator";

interface DisplayParams {
  showLabelOptional: boolean;
  showLabelRequired: boolean;
  suppressOffscreenOptional: boolean;
  suppressOffscreenRequired: boolean;
  showOptionalOnGroupFields: boolean;
}

@Component({ name: "ex-pattern" })
export default class ExamplePattern extends Vue {
  @Prop(Object())
  public readonly service!: object;

  @Prop(Object())
  public readonly text!: any;
  @Prop(Object())
  public readonly display!: DisplayParams;

  public clazz: string = "ds-ex";

  @Provide()
  resolveTxt(key: string, def: string): string {
    if (this.text && this.text[key]) {
      return this.text[key];
    }
    return def;
  }

  getDisplayParams(): DisplayParams {
    if (this.display) {
      return this.display;
    }
    return {
      showLabelOptional: true,
      showLabelRequired: false,
      suppressOffscreenOptional: false,
      suppressOffscreenRequired: true,
      showOptionalOnGroupFields: false
    };
  }

  @Provide()
  displayParams = this.getDisplayParams();

  @Provide()
  addContentClass(clazz: string) {
    this.clazz = clazz;
  }

  @Provide()
  getUserContext(): any {
    return {};
  }

  @Provide()
  getService(): object {
    return this.service;
  }

  @Provide()
  getMenu(): any {
    return [];
  }
}
</script>
